import React, { useEffect, useState } from 'react'
import Button from '@mui/material/Button';
import { actionTypes, useStateValue } from "./../../store";
const BtnAddToCart = ({ pid, whsid, inventoryItemId, btnaddcallback, pname, pimg, pcat, dealerid, enabledbtn }) => {
    const [{ cartitemcount }, dispatch] = useStateValue();
    const addToCart = () => {
        if (whsid == '') {
            dispatch({ type: actionTypes.SET_MSGALERTTYPE, value: 'error' });
            dispatch({ type: actionTypes.SET_MSGALERTDATA, value: 'Select Delivery Pincode' });
            dispatch({ type: actionTypes.SET_MSGALERT, value: true });
            btnaddcallback(true);
        }
        else {
            btnaddcallback(false);
            var existing_hcart = JSON.parse(localStorage.getItem("h_ct"));
            if (existing_hcart == null) existing_hcart = [];
            var entry = {
                "id": pid,
                "whsid": whsid,
                "dealerid": dealerid,
                "pname": pname,
                "pimg": pimg,
                "pcat": pcat,
                "inventoryItemId": inventoryItemId,
                "qty": 1,
            };
            var dataMatch = existing_hcart.map(t => t.id);
            if (dataMatch.includes(pid)) {
            } else {
                existing_hcart.push(entry);
                localStorage.setItem("h_ct", JSON.stringify(existing_hcart));
                dispatch({ type: actionTypes.SET_MINICARTITEM, value: cartitemcount + 1 });
                dispatch({ type: actionTypes.SET_MSGALERTTYPE, value: 'success' });
                dispatch({ type: actionTypes.SET_MSGALERTDATA, value: 'Product added' });
                dispatch({ type: actionTypes.SET_MSGALERT, value: true });
            }

        }
    }
    const gotoCart = () => {
       // console.log('hivarun')
        dispatch({ type: actionTypes.SET_MINICART, value: true });
    }

    const [checkitemincart, setVisibleGoBtn] = useState(false)

    useEffect(() => {
        var checkcart = (JSON.parse(localStorage.getItem('h_ct')) || []);
        if (checkcart?.length > 0) {
            var entry = checkcart.find(function (e) { return e.id == pid; });
            if (entry) {
                setVisibleGoBtn(true)
            }
            else {
                setVisibleGoBtn(false)
            }
        }
    }, [addToCart]);


    return (
        <>
            {checkitemincart ? <>
                <Button variant="contained" type="submit" color="warning" className='w-100 ' onClick={() => gotoCart()} >GO TO CART</Button></> : <>
                <Button   disabled={enabledbtn} variant="contained" type="submit" color="error" className='w-100 addCartbtn text-uppercase' onClick={() => addToCart()} >ADD TO CART</Button></>}
            {/* <Button variant="contained" type="submit" color="warning" className='w-100' onClick={() => gotoCart()} >GO TO CART</Button> */}
        </>
    )
}

export default BtnAddToCart